import { Component, computed, inject } from '@angular/core';
import { Api3Service } from '@app/services/api3.service';
import { HealthService } from '@app/services/health.service';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-tech-issues-banner',
  imports: [TranslocoPipe],
  standalone: true,
  template: `
    @if (showBanner()) {
      <div class="flex items-center justify-center gap-3 bg-violet-600 p-2 text-white">
        <p class="mx-auto px-1 text-center text-sm xl:text-base">
          <strong class="uppercase">{{ 'global.attention' | transloco }} -</strong>
          <!-- <i class="pi pi-exclamation-triangle !text-lg"></i> -->
          {{ 'global.error.banner.techIssues' | transloco }}
        </p>
      </div>
    }
  `,
})
export class TechIssuesBannerComponent {
  api3Service = inject(Api3Service);
  healthService = inject(HealthService);

  showBanner = computed(
    () =>
      this.healthService
        .healthStatus()
        .filter((service) => service.status === 'red')
        .map((service) => service.name).length > 0,
  );
}
